import React from 'react'
import Lottie from "lottie-react";
import animationData from '../animations/error-404.json'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet';
import { useAppTranslation } from '../i18n/useAppTranslation';

type Props = {}

const NotFound = (props: Props) => {
    const { t } = useAppTranslation(["errors"]);
    return (
        <div style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <Helmet>
                <title key="title">
                    {t("errors:notFound.title")} | Chain Of Legends
                </title>
            </Helmet>
            <motion.div
                transition={{ duration: 0.3, delay: 0.1 }} initial={{ y: 250, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -250, opacity: 0 }}
            >
                <Lottie
                    animationData={animationData}
                    style={{ width: 300, height: 'auto' }}
                    autoPlay
                    loop={true}
                />
            </motion.div>
            <motion.p
                transition={{ duration: 0.3, delay: 0.2 }} initial={{ y: 250, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 250, opacity: 0 }}
                className='dark-yellow text-center fs-big'>
                {t("errors:notFound.message")}
            </motion.p>

        </div >
    )
}

export default NotFound
